//ALPHABETICALLY ORDERLY

const dictionary = {
  'USERS': {
    'EN': 'Users',
    'ES': 'Usuarios'
  },
  'CLIENTS': {
    'EN': 'Clients',
    'ES': 'Clientes'
  },
  'DASHBOARD': {
    'EN': 'Dashboard',
    'ES': 'Resumen'
  },
  'PACKAGES': {
    'EN': 'Packages',
    'ES': 'Paquetes'
  },
  'TRANSFERS': {
    'EN': 'Transfers',
    'ES': 'Transferencia'
  },
  'REPORTS': {
    'EN': 'Reports',
    'ES': 'Reportes'
  },
};

export {
  dictionary
}